<template>
    <div>       
        <v-row>
            <v-col sm="12" style="display:flex; align-items:center;">
                There are {{schools.length}} different schools of maneuvers, with 9 levels, with 5 different types. Most of these remain unchanged from default Path of War rules. <v-spacer></v-spacer>
                <v-checkbox dense class="mt-0 mb-0 mr-6" height="11px" v-model="showGameDesc" label="Show Non-Roguelike Descriptions"></v-checkbox>
            </v-col>
        </v-row>
         <v-row>            
            <v-col sm="5">
                <h3>Links</h3>
                    <v-row no-gutters>
                        <v-col sm="4" v-for="school in schools" :key="school">
                            <li><a @click="scrollTo(school)" >{{capitalize(school)}}</a></li>
                        </v-col>
                    </v-row>
                    <br/><div><a @click="scrollTo('Finishers')" style="font-size:24px">Finishers Section-></a></div>

                <!-- <v-row v-for="y in 3" :key="y" no-gutters>
                     <v-col sm="4" v-for="x in 8" :key="x">
                        <ul>
                            <li><a @click="scrollTo(schools[x-1 + ((y-1)*8)])" >{{schools[x-1 + ((y-1)*8)][0].toUpperCase() + schools[x-1 + ((y-1)*8)].substr(1)}}</a></li>
                        </ul>
                    </v-col>
                </v-row> -->
            </v-col>
            <v-col sm="4">
                <h3 class="mb-4">Level Filters:</h3>
                <v-row no-gutters>
                    <v-col sm="6" style="" v-for="level in levels" :key="level">
                        <v-checkbox dense class="mt-0 mb-0" height="11px" v-model="filters.levels[level]" :label="'Level ' + level "></v-checkbox>
                    </v-col>                    
                </v-row>                
            </v-col>
            <v-col sm="3">
                 <h3 class="mb-4">Type Filters:</h3>
                <v-checkbox v-for="type in types" :key="type" dense class="mt-0 mb-0" height="11px" v-model="filters.types[type]" :label="type"></v-checkbox>
            </v-col>
         </v-row>
        <br/><br/>
        
        
        
        <div v-for="school in schools" :key="school">
            <h2 :id="school" style="color:black;font-size:32px">{{capitalize(school)}}:</h2>
            <v-divider></v-divider>
            <div v-for="level in levels" :key="level">      
                <div v-if="filters.levels[level]">  
                <h2 v-if="filters.levels[level]" :id="level" style="color:cornflowerblue">{{capitalize(school)}} Level {{level}}:</h2>            
                <table style="width:100%">
                    <tr>
                        <th>Name</th>                        
                        <th>Type</th>
                        <th>Initiation Action</th>
                        <th>Range</th>
                        <th>Duration</th>
                        <th>Description</th>
                    </tr>
                    <tr v-for="maneuver in sortedManeuvers(level, school)" :key="maneuver.name"> 
                        <td style="padding-left:4px">{{maneuver.name}}</td>                    
                        <td style="padding-left:4px; padding-right:4px">{{maneuver.type}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{maneuver.initiationAction}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{maneuver.range}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{maneuver.duration}}</td>
                        <td v-if="!showGameDesc" style="padding-left:4px">{{maneuver.longDesc}}</td>
                        <td v-else style="padding-left:4px">{{maneuver.gameDesc && maneuver.gameDesc.length > 0 ? maneuver.gameDesc : maneuver.longDesc}}</td>
                    </tr>
                </table>  
                <br/>     
                </div>   
            </div>
        </div>
        <h1 id="Finishers">FINISHERS:</h1>
        <p>Total Finishers: {{maneuvers.filter(maneuver=> maneuver.type=="Finisher" && maneuver.school != 'enlightenedPath').length}}</p>
        <div>
            <table style="width:100%">
                <tr><th></th><th v-for="comboTag in comboTags" v-bind:key="comboTag">{{comboTag}}</th></tr>
                <tr v-for="comboTag1 in comboTags" v-bind:key="comboTag1">
                    <th>{{comboTag1}}</th>                    
                    <th v-for="comboTag2 in comboTags" v-bind:key="comboTag2">
                        <div>
                            <span @click="setDialog(comboTag1,comboTag2)" style="cursor: pointer">
                                {{sharedTag(comboTag1,comboTag2)}}
                            </span>
                        </div>
                    </th>
                </tr>
            </table>  
        </div>
        <div>
            <h2 class="mt-4">Filters:</h2
                >(You can also click on the numbers in the above table to view the maneuvers that have those tags) <br/>
            <v-row class="mr-8 ml-0 mt-2">                    
            <v-checkbox
                v-model="filters.tagFilterType"
                label="At Least Includes"
                value="inclusive"
                class="d-inline-block ml-0 mr-4 pl-0"
            ></v-checkbox>
            <v-checkbox
                v-model="filters.tagFilterType"
                label="Only Includes"
                value="only"
                class="d-inline-block mr-4" 
            ></v-checkbox>
            <v-checkbox
                v-model="filters.tagFilterType"
                label="Includes All"
                value="exclusive"
                class="d-inline-block"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                class="mr-8"
                @click="clearFilters"
            >
                Clear Filters
            </v-btn>
            </v-row>
            <v-row class="mb-6">
                <v-col sm="1" style="height:40px" v-for="tag in comboTags" :key="tag">
                    <v-checkbox
                        v-model="filters.selectedTags"
                        :label="tag"
                        :value="tag"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </div>

        <div v-for="level in levels" :key="level">
            <div v-if="filters.levels[level]">  
            <h2 v-if="filters.levels[level]" :id="level" style="color:cornflowerblue">Level {{level}}:</h2>            
            <table style="width:100%">
                <tr>
                    <th>Name</th>
                    <th>Combo Tags</th>
                    <th>Initiation Action</th>
                    <th>Range</th>
                    <th>Duration</th>
                    <th>Description</th>
                </tr>
                <tr v-for="maneuver in filteredFinishers(level)" :key="maneuver.name"> 
                    <td style="padding-left:4px">{{maneuver.name}}</td>                    
                    <td style="padding-left:4px; padding-right:4px" v-if="maneuver.comboTags"><span v-for="tag in maneuver.comboTags" v-bind:key="tag">{{tag}}, </span></td>
                    <td style="padding-left:4px; padding-right:4px" v-else>{{capitalize(maneuver.school)}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{maneuver.initiationAction}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{maneuver.range}}</td>
                    <td style="padding-left:4px; padding-right:4px">{{maneuver.duration}}</td>
                    <td v-if="!showGameDesc" style="padding-left:4px">{{maneuver.longDesc}}</td>
                    <td v-else style="padding-left:4px">{{maneuver.gameDesc && maneuver.gameDesc.length > 0 ? maneuver.gameDesc : maneuver.longDesc}}</td>
                </tr>
            </table>  
            <br/>     
            </div>   
        </div>
        <v-icon style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
        <v-dialog v-model="showFinisherDialog" max-height="50%" max-width="80vw">
            <v-card>
                <v-card-title>
                    <span v-if="dialogData[0] == dialogData[1]">Maneuvers: Pure {{dialogData[0]}}</span>
                    <span v-else>Shared Maneuvers: {{dialogData[0]}} & {{dialogData[1]}}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="showFinisherDialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <div v-for="maneuver in getSharedManeuvers(dialogData[0],dialogData[1])" :key="maneuver.name">
                        <v-card dense class="my-1">
                            <v-card-title>
                                {{maneuver.name}}
                            </v-card-title>
                            <v-card-text style="color:black">
                                <div>
                                    ComboTags: <span v-for="tag in maneuver.comboTags" v-bind:key="tag">{{tag}}, </span><br/>
                                    Level: {{ maneuver.level }}<br/>
                                    Initiation Action: {{ maneuver.initiationAction }}<br/>
                                    Duration: {{ maneuver.duration }}<br/>
                                </div>
                                <div v-if="!showGameDesc" style="padding-left:4px">{{maneuver.longDesc}}</div>
                                <div v-else style="padding-left:4px">{{maneuver.gameDesc && maneuver.gameDesc.length > 0 ? maneuver.gameDesc : maneuver.longDesc}}</div>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
//
import {maneuvers} from "../../../play/data"
import {comboTagText} from "../../../play/constants"
import {
VCol,
VRow,
VCheckbox,
VDivider,
VIcon,
VCard,
VCardTitle,
VCardText,
VDialog,
VBtn,
VSpacer,
} from "vuetify/lib";
export default {
    components: {
        VRow,
        VCol,
        VCheckbox,
        VDivider,
        VIcon,
        VCard,
        VCardTitle,
        VCardText,
        VDialog,
        VBtn,
        VSpacer,
    },
    props:{
    },
    data(){
        return{
            showGameDesc:false,
            showFinisherDialog:false,
            dialogData:[],
            maneuvers: maneuvers,
            finishers:maneuvers.filter(maneuver=>maneuver.type == "Finisher"),
            schools:["blackSeraph","brokenBlade","brutalCrocodile","burningCitadel","crimsonReaper","cursedRazor","elementalFlux","enlightenedPath","eternalGuardian","goldenLion","heartOfTheMaelstrom","indomitableWill","ironTortoise","mithralCurrent","piercingThunder","primalFury","radiantDawn","rivenHourglass","scarletThrone","shadowAssassin","shatteredMirror","silverCrane","sleepingGoddess","solarWind","steelSerpent","sterlingSovereignty","tempestGale","thrashingDragon","unquietGrave","veiledMoon"],
            types:["Boost","Strike","Stance","Counter","Finisher"],
            comboTags:[...comboTagText,"Elemental"],
            levels:[0,1,2,3,4,5,6,7,8,9],
            filters:{
                levels:{
                    0: false,
                    1: true,
                    2: true,
                    3: true,
                    4: true,
                    5: true,
                    6: true,
                    7: true,
                    8: true,
                    9: true,
                },
                types:{
                    Finisher: true,
                    Boost: true,
                    Stance: true,
                    Strike: true,
                    Counter: true,
                },
                schools:{
                    blackSeraph: true,
                    brokenBlade: true,
                    cursedRazor: true,
                    elementalFlux: true,
                    eternalGuardian: true,
                    goldenLion: true,
                    ironTortoise: true,
                    mithralCurrent: true,
                    piercingThunder: true,
                    primalFury: true,
                    radiantDawn: true,
                    rivenHourglass: true,
                    scarletThrone: true,
                    shatteredMirror: true,
                    silverCrane: true,
                    sleepingGoddess: true,
                    solarWind: true,
                    steelSerpent: true,
                    tempestGale: true,
                    thrashingDragon: true,
                    unquietGrave: true,
                    veiledMoon: true,     
                    heartOfTheMaelstrom: true,
                    burningCitadel: true,
                },
                tagFilterType: 'none',
                selectedTags: [],
            },
        }
    },
  
  methods:{
      sortedManeuvers(level, school){
        let filters = {}
        Object.keys(this.filters).forEach(key=>{
            filters[key] = []
            Object.keys(this.filters[key]).forEach(subKey=>{
                if(this.filters[key][subKey]){
                    filters[key].push(subKey)
                }
            })
        })
        let sortedManeuvers = maneuvers.filter(maneuver=>maneuver.level == parseInt(level) && maneuver.school == school && filters.types.includes(maneuver.type) && !maneuver.secret)
        let sorted = sortedManeuvers.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))       
        return sorted
      },
      scrollTo(id){
        if(id == "top"){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let section = document.getElementById(id)
            section.scrollIntoView({behavior: "smooth"})
        }
      },    
      capitalize(str){  
        for(let x = 0; x < str.length; x++){
            if(str[x].toUpperCase() == str[x]){
                str = str.substring(0,x) + " " + str.substring(x,str.length)
                x++
            }
        }            
        let newStr = str[0].toUpperCase() + str.substring(1)
        return newStr
      },
      
      sharedTag(comboTag1,comboTag2){
        if(comboTag1 == "") return ""
        if(comboTag1 == comboTag2){
            let shared1 = maneuvers.filter(maneuver=> maneuver.type == "Finisher" && maneuver.comboTags && maneuver.comboTags.length == 1 && maneuver.comboTags[0] == comboTag1 )
            let shared2 = maneuvers.filter(maneuver=> maneuver.type == "Finisher" && maneuver.comboTags && maneuver.comboTags.includes(comboTag1) && maneuver.comboTags.includes(comboTag2))
            return `Pure: ` + shared1.length + `\nTotal: ` + shared2.length
        }else{
            let shared = maneuvers.filter(maneuver=> maneuver.type == "Finisher" && maneuver.comboTags && maneuver.comboTags.includes(comboTag1) && maneuver.comboTags.includes(comboTag2))
            return shared.length 
        }
      },
      filteredFinishers(level) {
            let maneuversAtLevel = this.finishers.filter(maneuver => 
                maneuver.type == 'Finisher' && 
                maneuver.comboTags && 
                maneuver.level == level
            );

            if (this.filters.selectedTags.length === 0 || this.filters.tagFilterType === 'none') {
                return maneuversAtLevel;
            }

            if (this.filters.tagFilterType === 'inclusive') {
                return maneuversAtLevel.filter(maneuver => 
                    maneuver.comboTags.some(tag => this.filters.selectedTags.includes(tag))
                );
            } else if (this.filters.tagFilterType === 'only') {
                return maneuversAtLevel.filter(maneuver => 
                    maneuver.comboTags && 
                    maneuver.comboTags.some(tag => this.filters.selectedTags.includes(tag)) &&
                    maneuver.comboTags.every(tag => this.filters.selectedTags.includes(tag))
                );
            } else { 
                return maneuversAtLevel.filter(maneuver => 
                    this.filters.selectedTags.every(tag => maneuver.comboTags.includes(tag))
                );
            }
        },
        getSharedManeuvers(comboTag1, comboTag2) {
            if (comboTag1 == comboTag2) {
                return this.finishers.filter(maneuver => 
                    maneuver.type == "Finisher" && 
                    maneuver.comboTags && 
                    maneuver.comboTags.length == 1 && 
                    maneuver.comboTags[0] == comboTag1
                );
            } else {
                return this.finishers.filter(maneuver => 
                    maneuver.type == "Finisher" && 
                    maneuver.comboTags && 
                    maneuver.comboTags.includes(comboTag1) && 
                    maneuver.comboTags.includes(comboTag2)
                );
            }
        },
        setDialog(comboTag1,comboTag2){
            this.dialogData = [comboTag1,comboTag2]
            this.showFinisherDialog = true
        },
        clearFilters() {
            this.filters.tagFilterType = 'none';
            this.filters.selectedTags = [];
        }
  },
   mounted(){
        let finishers = maneuvers.filter(maneuver=> maneuver.type == "Finisher" && maneuver.level > 5)
        //console.log("Length: ", finishers.length)
        let tags = []
        finishers.forEach(finisher=>{
        if(finisher.comboTags){
            finisher.comboTags.forEach(tag=>{
            if(tags[tag]){
                tags[tag] += 1
            }else{
                tags[tag] = 1
            }
            })
        }
        })
        console.log(tags)
        // let existingTags = Object.keys(tags)
        // console.log(existingTags)
        // let noTags = comboTagText.filter(comboTag=> !existingTags.includes(comboTag)) 
        // console.log(noTags)
        //this.comboTags.push("Elemental")
    },

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
.small-label .v-label{
  font-size:12px;
  margin-top:0px;
  margin-bottom:0px;
  padding-top:0px;
}
.small-label .v-messages.theme--light{
  height:0px;
  display:none;
}
.v-tooltip__content {
  opacity: 1.1 !important;
  background-color:rgb(97,97,97,1)!important;
}
</style>